import moment from 'moment';
import { HistoryFilterPayload, HistoryState, IHistoryState, INavigation } from './types';

const getters = {
  getHistory(state: HistoryState) {
    return state.history;
  },
  getHistoryState(state: HistoryState): IHistoryState {
    return state.historyState;
  },
  getNavigationConfiguration(state: HistoryState): INavigation {
    return state.navigation;
  },
  getTotal(state: HistoryState) : number {
    return state.history.totalSize;
  },
  getErrorMessage(state: HistoryState) : string {
    return state.errorMessage;
  },
  getIsLastHistoryPage(state: HistoryState) : boolean {
    return state.navigation.isLastHistoryPage;
  },
  // Filters adapted to Vuetify's Treeview
  getFiltersMeta(state: HistoryState): any {
    const filters = state.filters.reduce((acc, curr) => {
      const item: { name: string; level: number; children?: any[] } = { name: curr.name, level: 0 };
      if (curr.categories) {
        item.children = curr.categories.map((i) => {
          const cat: { name: string; level: number; parentCategory: string; children?: any[] } = { name: i.name, level: 1, parentCategory: item.name };
          if (i.subCategories) {
            cat.children = Array.from(i.subCategories, sub => ({ name: sub, level: 2, parentCategory: `${item.name}_${cat.name}` }));
          }
          return cat;
        });
      }
      acc.push(item);
      return acc;
    }, [] as any[]);
    return filters;
  },
  getSelectedFilters(state: HistoryState): HistoryFilterPayload {
    return state.selectedFilters;
  },
  getSelectedFiltersFlattened(state: HistoryState): any[] {
    const filters = state.selectedFilters;
    const flattened: any[] = [];
    const notIncluded = ['start', 'size', 'from', 'to', 'subCategory'];
    const dateKey = ['from', 'to'];
    if (!filters) {
      return flattened;
    }
    Object.entries(filters).forEach(([key, value]) => {
      if (value && dateKey.includes(key)) {
        flattened.push({ key, value: moment.unix(value).format('DD/MM/YYYY') });
      }
      if (value && !notIncluded.includes(key)) {
        flattened.push({ key, value });
      }
    });
    return flattened;
  },
  getSubcategories(state: HistoryState): string[] {
    return state.selectedFilterCategories ? state.selectedFilterCategories : [];
  }
};
export default getters;
